import React from 'react'
import { PerPage } from "../../../constants/Common";
import TablePagination from '@mui/material/TablePagination';
import { useTranslation } from 'react-i18next';
export function PaginationComponent({paginationObject, page, handleChangePage, rowsPerPage, handleChangeRowsPerPage}) {
    const {t} = useTranslation();
    return (
        <>
            <TablePagination
                rowsPerPageOptions={PerPage}
                component="div"
                count={ parseInt(paginationObject.total === undefined ? 0 : paginationObject.total ) }
                page={ page }
                onPageChange={ handleChangePage }
                rowsPerPage={ rowsPerPage }
                onRowsPerPageChange={ handleChangeRowsPerPage }
                labelRowsPerPage={t("Show entries:")}
                sx={{
                    backgroundColor: '#FFFFFF',
                    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
                    borderRadius: '50px',
                    marginBottom: '30px',
                    '.MuiTablePagination-displayedRows': {
                    paddingTop: '15px'
                    },
                    '.MuiTablePagination-selectLabel': {
                    paddingTop: '15px'
                    }
                }}
            />
        </>
    )
}
